import React from 'react';

import AuthImage from './AuthImage';
import AuthFooter from './AuthFooter';
import NavBar from 'features/feature-auth-navbar';

import {
  LoginContentWrapper,
  LoginPageContentWrapper,
  LoginPageWrapper,
} from './styles';

/**
 * AuthPageWrapper component.
 *
 * This component wraps the contents of an authentication page.
 * It includes a navigation bar at the top, content in the middle,
 * and a footer at the bottom. The content can be customized by passing
 * child elements to this component.
 */
export const AuthPageWrapper = ({ children }: { children: JSX.Element }) => {
  return (
    <LoginPageWrapper>
      <NavBar />
      <LoginContentWrapper>
        <LoginPageContentWrapper>{children}</LoginPageContentWrapper>{' '}
        <AuthImage />
      </LoginContentWrapper>
      <AuthFooter />
    </LoginPageWrapper>
  );
};
